import React from "react";
import { Box, Checkbox } from "@mui/material";
import JoinDateFilterPopover from "../common/JoinDateFilterPopover";
import StatusFilterPopover from "../common/StatusFilterPopover";
import EvidenceFilterPopover from "../common/EvidenceFilterPopover";
import RoleFilterPopover from "../common/RoleFilterPopover";

/**
 * Generate employee table columns configuration
 * @param {Object} params - Column configuration parameters
 * @returns {Array} Column definitions
 */
export const getEmployeeColumns = ({
  theme,
  isAllSelected,
  isSomeSelected,
  handleSelectAll,
  joinDateFilter,
  setJoinDateFilter,
  statusFilter,
  setStatusFilter,
  evidenceFilter,
  setEvidenceFilter,
  roleFilter,
  setRoleFilter,
  roleOptions,
}) => [
  {
    label: (
      <Checkbox
        size="small"
        checked={isAllSelected}
        indeterminate={isSomeSelected}
        onChange={handleSelectAll}
        sx={{
          color: theme.palette.grey[400],
          "&.Mui-checked": {
            color: theme.palette.primary.main,
          },
          "&.MuiCheckbox-indeterminate": {
            color: theme.palette.primary.main,
          },
        }}
      />
    ),
    field: "checkbox",
    align: "left",
    width: "4%",
  },
  {
    label: "Employee Name",
    field: "employeeName",
    align: "left",
    width: "24%",
  },
  {
    label: (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        Role
        <RoleFilterPopover
          options={roleOptions}
          activeFilters={roleFilter}
          onFilterChange={setRoleFilter}
        />
      </Box>
    ),
    field: "employeeRole",
    align: "left",
    width: "14%",
  },
  {
    label: (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        Join Date
        <JoinDateFilterPopover
          onFilterChange={setJoinDateFilter}
          activeFilter={joinDateFilter}
        />
      </Box>
    ),
    field: "joinDate",
    align: "left",
    width: "12%",
  },
  {
    label: (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        Status
        <StatusFilterPopover
          onFilterChange={setStatusFilter}
          activeFilters={statusFilter}
        />
      </Box>
    ),
    field: "status",
    align: "left",
    width: "10%",
  },
  {
    label: "Reason",
    field: "reason",
    align: "left",
    width: "26%",
  },
  {
    label: (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        Evidence
        <EvidenceFilterPopover
          onFilterChange={setEvidenceFilter}
          activeFilters={evidenceFilter}
        />
      </Box>
    ),
    field: "evidenceCount",
    align: "left",
    width: "10%",
  },
];
